import React from 'react'
import Button from '../../components/ui/button/Button'
import { ListFilter, X } from 'lucide-react'
import { useBusiness } from '../../context/BusinessContext'
import Notify from '../../components/common/Notify'
const BusinessFilterButton = () => {
    const { setOpenFilter, totalFilters, clearFilters } = useBusiness()

    return (
        <Button variant='outline' size='sm' onClick={() => setOpenFilter(true)}>
            <div className='relative'>
                <ListFilter className='w-4 h-4' />
                {totalFilters > 0 && <Notify top='-top-0.5' right='-right-1' />}
            </div>
            <div className='flex items-center gap-1'>
                Filtros
                {totalFilters > 0 && (
                    <>
                        <p className='text-xs'>({totalFilters})</p>
                        <X
                            className='w-4 h-4 text-red-500'
                            onClick={e => {
                                clearFilters()
                                e.stopPropagation()
                            }}
                        />
                    </>
                )}
            </div>
        </Button>
    )
}

export default BusinessFilterButton
